import { completed, type Comic } from '@/mocks/comics';
import ComicCard from './ComicCard';
import SectionHeader from './SectionHeader';

interface CompletedProps {
  onSelect: (comic: Comic) => void;
}

export default function Completed({ onSelect }: CompletedProps) {
  return (
    <section id="completed" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeader
          kicker="完结作品"
          title="一口气看到结局的精品"
          desc="已完结高分韩漫，情节完整、故事圆融，适合不想等待更新的读者，从容追完每一部。"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {completed.map((comic) => (
            <div key={comic.id} className="relative">
              <span className="absolute -top-2 left-2 z-10 px-2.5 py-0.5 rounded-full bg-accent-500 text-background-50 text-[11px] font-bold">
                已完结
              </span>
              <ComicCard comic={comic} onSelect={onSelect} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}